<div class="parallax-chat-shell" [class.parallax-chat-shell--active]="curtainActive">
  <section class="parallax-curtain" #parallaxCurtain [class.parallax-curtain--flip]="curtainFlipActive">
    <div class="parallax-curtain__content">
      <h1 class="parallax-curtain__title">
        <span *ngFor="let letter of parallaxLetters">
          {{ letter === ' '? '\u00A0' : letter }}
        </span>
      </h1>
      <p class="parallax-curtain__subtitle">
        Scroll down to unveil the full workspace and glide into your conversation.
      </p>
    </div>
  </section>
  <div class="parallax-reveal" [class.parallax-reveal--compressed]="curtainActive"></div>
  <div class="parallax-main" #parallaxMain [class.parallax-main--active]="curtainActive">
    <div class="main-container clarichat">
    <div class="top-bar d-flex justify-content-between align-items-center">
      <div class="top-bar-actions"></div>
      <div class="top-bar-actions top-bar-actions--right">
        <button
          type="button"
          class="top-bar-pill top-bar-pill--model"
          (click)="openAICatalog()">
          <span class="pill-label">Model</span>
          <span class="pill-value">{{ selectedModelName }}</span>
        </button>
        <div class="parallax-tools-menu" (click)="$event.stopPropagation()">
          <button
            type="button"
            class="top-bar-pill top-bar-pill--tools"
            [class.active]="toolsMenuOpen"
            (click)="toggleToolsMenu()">
            <span class="pill-label">Tools</span>
            <i class="fas fa-chevron-down pill-icon" [class.rotated]="toolsMenuOpen"></i>
          </button>
          <div class="parallax-tools-dropdown" *ngIf="toolsMenuOpen">
            <button type="button" class="tools-item" (click)="openModelSpecDialog(); toolsMenuOpen = false">
              <span class="icon"><i class="fas fa-info-circle"></i></span>
              <span>{{ selectedModelName }}</span>
            </button>
            <button type="button" class="tools-item" (click)="openAICatalog(); toolsMenuOpen = false">
              <span class="icon"><img src="assets/select-white.svg" alt="AI" /></span>
              <span>AI catalog</span>
            </button>
            <button
              type="button"
              class="tools-item"
              [disabled]="messageHistory.length === 0"
              (click)="recallLastMessage(); toolsMenuOpen = false">
              <span class="icon"><i class="fas fa-clock-rotate-left"></i></span>
              <span>Repeat prompt</span>
            </button>
            <button type="button" class="tools-item" (click)="startTour(); toolsMenuOpen = false">
              <span class="icon"><i class="fas fa-question-circle"></i></span>
              <span>Start tour</span>
            </button>
          </div>
        </div>
      </div>
    </div>

  <div class="messages-container" #messagesContainer>

    <!-- Right Scroll Rail -->
    <div class="scroll-rail" *ngIf="currentMessages.length > 0">
      <button
        class="rail-tick"
        *ngFor="let msg of userMessages; let i = index"
        [class.active]="i === activeMessageIndex"
        (click)="scrollToMessage(i)"
        aria-label="Jump to message">
      </button>
    </div>
    <div class="left-gutter" *ngIf="latestPromptText">
      <button
        type="button"
        class="repeat-gutter-button"
        (click)="recallLastMessage()"
        aria-label="Repeat previous prompt">
        <span class="repeat-gutter-header">
          <i class="fas fa-clock-rotate-left" aria-hidden="true"></i>
          <span>Repeat prompt</span>
        </span>
        <span class="repeat-gutter-preview">{{ latestPromptText }}</span>
      </button>
    </div>
</div>

    <!-- Pinned Navigation -->
    <div class="pinned-nav-top-right" *ngIf="pinnedMessages.length > 0">
      <div class="pin-stack-anchor">

        <!-- Up Arrow -->
        <button class="arrow prev" type="button" (click)="scrollToPinned(false); $event.stopPropagation()">
          <i class="fas fa-arrow-up"></i>
        </button>

        <!-- Down Arrow -->
        <button class="arrow next" type="button" (click)="scrollToPinned(true); $event.stopPropagation()">
          <i class="fas fa-arrow-down"></i>
        </button>

        <!-- Pin Count Pill -->
        <button type="button" class="pin-stack-pill" aria-label="Pinned messages" (click)="togglePinStack($event)">
          📌 {{ pinnedMessages.length }} pinned
        </button>

        <!-- Clear All Pins -->
        <button type="button" class="pin-clear-btn" aria-label="Clear all pinned messages" (click)="clearAllPins($event)">
          <i class="fas fa-xmark"></i>
        </button>

        <!-- Pin Stack Preview -->
        <div class="pin-stack-preview" *ngIf="showPinStack" (click)="$event.stopPropagation()">
          <div class="pin-stack-title">
            📌 {{ pinnedMessages.length }} pinned
          </div>

          <button type="button" class="pin-stack-item" *ngFor="let pm of pinnedMessages; trackBy: trackMsg"
                  (click)="jumpToPinned(pm.id); $event.stopPropagation()">
            <div class="pin-stack-snippet">
              {{ pm.content || '[no text]' }}
            </div>
            <div class="pin-stack-meta">
              {{ pm.modelDisplayName || '' }}
              <span *ngIf="pm.timestamp">• {{ pm.timestamp | date:'short' }}</span>
            </div>
          </button>
        </div>

      </div>
    </div>

    <!-- Chat Placeholder -->
    <div class="chat-placeholder-grid-container" *ngIf="currentMessages.length === 0 &&!isLoading">
      <div class="placeholder-wrapper" id="placeholderNavArrows">
        <div class="placeholder-content">
          <img
            [src]="currentOption.logoUrl"
            class="grid-item-logo vendor-logo"
            [class.fading]="logoFading"
          />
          <h1 class="placeholder-title" *ngIf="!showMainSubtitle" [class.fading]="modelNameFading">
            <span [class]="modelNameClass"
                  style="direction:ltr; unicode-bidi:isolate; display:inline-block; white-space:nowrap;">
              <span
                *ngFor="let letter of modelNameLetters; let i = index; trackBy: trackByLetter"
                class="model-name-letter"
                [class.waving]="isLetterWaving(i)"
                [class.dissolving]="modelNameFading"
                [style.color]="getLetterColor(i)"
                [style.--letter-index]="i"
                [style.animation-delay]="isLetterWaving(i)? '0s' : '0s'"
              >{{ letter.char === ' '? '\u00A0' : letter.char }}</span>
            </span>
          </h1>
          <h1 class="placeholder-subtitle jizz bigal-sub" *ngIf="showMainSubtitle">
            The Leading AI Models, All In One Place.
          </h1>
          <h1 class="placeholder-subtitle bigal-sub" *ngIf="!showMainSubtitle" [class.fading]="logoFading">
            {{ currentPlaceholder }}
          </h1>
        </div>
      </div>
    </div>

    <!-- Message Display -->
    <ng-container *ngFor="let msg of currentMessages; let i = index; trackBy: trackMsg">
      <div class="message" *ngIf="!shouldHideMessage(msg, i)"
           [id]="'msg-' + msg.id"
           [ngClass]="{'user-message': msg.role === 'user', 'assistant-message': msg.role === 'assistant'}">

        <!-- Pin Buttons -->
        <button *ngIf="!msg.pinned" type="button" class="pin-corner-btn" (click)="onPinClick(msg, $event)"
                [attr.aria-pressed]="msg.pinned" [attr.title]="msg.pinned? 'Unpin message' : 'Pin message'">
          <img src="assets/svg/pin.svg" height="25px" />
        </button>

        <button *ngIf="msg.pinned" type="button" class="pin-corner-btn" (click)="onPinClick(msg, $event)"
                [attr.aria-pressed]="msg.pinned" [attr.title]="msg.pinned? 'Unpin message' : 'Pin message'">
          <i class="fa-thumbtack" [ngClass]="{'fa-solid pinned': msg.pinned}"></i>
        </button>

        <div class="message-toggle-row message-toggle-row--top">
          <button
            class="message-toggle-chip"
            type="button"
            [attr.aria-pressed]="isBlockCollapsed(i)"
            [attr.title]="isBlockCollapsed(i)? 'Expand message' : 'Collapse message'"
            (click)="toggleQaCollapse(msg, i, $event)">
            <i class="fas" [ngClass]="isBlockCollapsed(i)? 'fa-chevron-down' : 'fa-chevron-up'"></i>
            Toggle
          </button>
        </div>

        <!-- Message Content -->
        <div *ngIf="msg.content &&!isBlockCollapsed(i)" class="markdown prism-content" [innerHTML]="convertMarkdown(getMessageDisplayContent(msg))" appCodeHighlight></div>
        <div *ngIf="msg.role === 'user' && isBlockCollapsed(i)" class="qa-collapsed-summary">
          - Question Collapse -
        </div>
        <div *ngIf="msg.role === 'assistant' && isBlockCollapsed(i)" class="qa-collapsed-summary">
          Response Collapse
        </div>

        <!-- DALL-E Image Section -->
        <div *ngIf="!isBlockCollapsed(i) && (msg.modelId === 'dale' || msg.modelId === 'dale2legacy') && (msg.image || (msg.images && msg.images.length > 0))" class="dalle-image">
          <img *ngIf="msg.image" [src]="msg.image" class="dalle-img" alt="Generated image" />
          <div *ngIf="msg.images && msg.images.length > 1" class="dalle-variants">
            <img *ngFor="let img of msg.images; let imgIndex = index" [src]="img" class="dalle-img variant" [alt]="'Generated image variant ' + (imgIndex + 1)" />
          </div>
        </div>

        <!-- Generic Image Section (for non-DALL-E models like Stability) -->
        <div *ngIf="!isBlockCollapsed(i) && (msg.image || (msg.images && msg.images.length)) && msg.modelId!== 'dale' && msg.modelId!== 'dale2legacy'" class="image-result">
          <img *ngIf="msg.image" [src]="msg.image" class="image-result__item" />
          <div class="image-result__variants" *ngIf="msg.images && msg.images.length > 0">
            <img *ngFor="let img of msg.images" [src]="img" class="image-result__item" />
          </div>
        </div>

  <div class="message-footer">
    <div class="message-footer-meta">
      <span class="message-timestamp">
        {{ msg.timestamp | date: 'short' }}
      </span>
      <span class="message-meta-chip" *ngIf="msg.role === 'user'">Me</span>
      <span class="message-meta-chip" *ngIf="msg.role === 'assistant' && (msg.modelDisplayName || msg.modelId)">
        {{ msg.modelDisplayName || msg.modelId }}
      </span>
      <button type="button" class="message-timestamp-copy" (click)="onActionCopy(msg, i)">
        Copy
      </button>
    </div>

    <div class="message-footer-actions">
      <span class="actions-anchor">
        <button
          class="actions-plus-btn"
          type="button"
          (click)="toggleActionsMenu(msg, $event)">
          +
        </button>

        <div class="actions-dropdown anchored" *ngIf="isActionsMenuOpen(msg)" (click)="$event.stopPropagation()">
          <button type="button" class="actions-item actions-item--copy" (click)="onActionCopy(msg, i)">
            <span class="icon me-2">📋</span> Copy
          </button>

          <button type="button" class="actions-item" (click)="onActionPin(msg)">
            <span class="me-2">{{ msg.pinned? '📌' : '🔖' }}</span>
            {{ msg.pinned? 'Unpin' : 'Pin' }}
          </button>

          <button type="button" class="actions-item" (click)="onActionCopyToClariChat(msg)">
            <i class="fa-solid fa-arrow-up-right-from-square me-2"></i>
            Add to ClariNotes
          </button>

          <button
            type="button"
            class="actions-item"
            *ngIf="msg.role === 'assistant'"
            (click)="exportMessageToGoogleDocs(msg)">
            <span class="icon me-2">📝</span> Create Google Doc
          </button>

          <button type="button" class="actions-item" (click)="exportMessageToPDF(msg)">
            <span class="icon me-2">📄</span> Export to PDF
          </button>

          <button type="button" class="actions-item" (click)="exportMessageToDOCX(msg)">
            <span class="icon me-2">📝</span> Export to DOCX
          </button>

          <button type="button" class="actions-item actions-item--danger" (click)="onActionDelete(msg, i)">
            <i class="fa-regular fa-trash-can me-2"></i>
            Delete message
          </button>
        </div>

        <span
          class="action-toast anchored"
          *ngIf="msg?.id && actionToastById[msg.id]"
          [ngClass]="actionToastById[msg.id].type">
          {{ actionToastById[msg.id].text }}
        </span>
      </span>
    </div>
  </div>

      </div>
    </ng-container>

    <!-- Loading Indicator -->
    <app-bird-loader *ngIf="isLoading" label="Thinking"></app-bird-loader>

    </div>

    <!-- Input Container -->
  <div class="bottomcontainer">
<div class="input-container">
  <div class="composer-shell" [class.expanded]="composerExpanded" [class.mobile-expanded]="hasSentMessage" [ngClass]="{ 'with-effort': selectedModel === 'o3' }">

    <input #fileInput type="file" accept="image/*"
           (change)="onFileSelected($event)"
           style="display:none">

    <input #audioImageInput type="file" accept="image/*"
           (change)="onAudioImageSelected($event)"
           style="display:none">

    <div class="textarea-wrapper">
      <textarea
        #chatTextarea
        id="chatInputTextarea"
        class="user-input-textarea"
        [(ngModel)]="userInput"
        rows="1"
        (input)="autoResize(chatTextarea)"
        [placeholder]="getTextareaPlaceholder()"
        (keydown.enter)="onEnter($event)"
        (keydown.shift.enter)="onShiftEnter($event, chatTextarea)"
        (keydown)="onKeyDown($event)"
        [disabled]="audioActive"
        [class.disabled-typing]="audioActive">
      </textarea>

      <div class="left-actions">
        <button id="micButton"
                class="btn-audio-fixed"
                type="button"
                (click)="onAudioIconClick()"
                matTooltip="Click to start voice">
          <i class="fas fa-plus" aria-hidden="true"></i>
        </button>
      </div>

      <!-- Right floating send -->
      <button id="sendMessageButton"
              class="btn-send-fixed"
              type="button"
              (click)="sendMessage()"
              [disabled]="isLoading || (!userInput.trim())">
        <i class="fas fa-arrow-up send-arrow-icon" aria-hidden="true"></i>
      </button>

      <button
        type="button"
        class="textarea-model-status"
        *ngIf="selectedModelName"
        (click)="openAICatalog()"
        aria-label="Open AI selector">
        <span class="textarea-model-name">{{ selectedModelName }}</span>
        <i class="fas fa-chevron-down textarea-model-chevron" aria-hidden="true"></i>
        <span class="textarea-reasoning" *ngIf="showModelNameReasoningDropdown">
          <span class="textarea-reasoning-ring" [style.--arc-angle]="getReasoningIndicatorArc()">
            <i class="fas fa-brain" aria-hidden="true"></i>
          </span>
          <span class="textarea-reasoning-label">{{ getReasoningLabel(selectedReasoningLevel) }}</span>
        </span>
      </button>

    </div>
  </div>
</div>
</div><!-- /parallax-main -->
</div><!-- /parallax-chat-shell -->